'use client';

import { Trophy } from 'lucide-react';

interface RulesContentProps { variant?: 'full' | 'compact'; }

export default function RulesContent({ variant = 'full' }: RulesContentProps) {
  return <div className="ev-rules">
    {variant === 'full' && <p className="ev-rules-intro">Bring 3–8 players. Take turns giving clues, playing cards, and finding the story hidden among them.</p>}
    <ol className="ev-rule-list">
      <li><div><h3>Tell a story</h3><p>The storyteller picks a card and gives a clue: a word, phrase, or sound.</p></div></li>
      <li><div><h3>Play a card</h3><p>Everyone else chooses a card that fits the clue. All played cards are shuffled.</p></div></li>
      <li><div><h3>Find the original</h3><p>Everyone but the storyteller votes for the storyteller’s card. You can’t vote for your own.</p></div></li>
      <li><div><h3>Score and pass it on</h3><p>Reveal the cards, add the points, and give the next player a turn to tell a story.</p></div></li>
    </ol>
    <section className="ev-rules-scoring"><h3 className="ev-section-title"><Trophy size={16} aria-hidden="true" /> The points</h3><dl><dt>Some players guess correctly</dt><dd>3 pts for storyteller<br />and correct guessers</dd><dt>Everyone or nobody guesses correctly</dt><dd>0 for storyteller<br />2 pts for everyone else</dd><dt>Votes on your submitted card</dt><dd>+1 pt per vote</dd></dl></section>
    <p className="ev-rules-tip">Leave a little mystery. The storyteller wants some people to find their card, but not everyone.</p>
  </div>;
}
